/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsGetPlugin } from "../funcs/pluginsGetPlugin.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Plugin } from "../models/components/plugin.js";
import {
  GetPluginRequest,
  GetPluginSecurity,
} from "../models/operations/getplugin.js";
import { unwrapAsync } from "../types/fp.js";
export type PluginQueryData = Plugin;

export function prefetchPlugin(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetPluginRequest,
  security?: GetPluginSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildPluginQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildPluginQuery(
  client$: GramCore,
  request: GetPluginRequest,
  security?: GetPluginSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<PluginQueryData>;
} {
  return {
    queryKey: queryKeyPlugin({
      id: request.id,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function pluginQueryFn(ctx): Promise<PluginQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsGetPlugin(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyPlugin(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "getPlugin", parameters];
}
